import {CALL_API} from  '../../middleware/api'
// ------------------------------------
// Buscar médico por email
// ------------------------------------

export const SEARCH_MEDICO_EMAIL_API_LOADING = 'SEARCH_MEDICO_EMAIL_API_LOADING';
export const SEARCH_MEDICO_EMAIL_API_SUCCESS = 'SEARCH_MEDICO_EMAIL_API_SUCCESS';
export const SEARCH_MEDICO_EMAIL_API_ERROR = 'SEARCH_MEDICO_EMAIL_API_ERROR';

const fetchMedicoEmail = (email) => ({
  [CALL_API]: {
    method: 'GET',
    types: [ SEARCH_MEDICO_EMAIL_API_LOADING, SEARCH_MEDICO_EMAIL_API_SUCCESS, SEARCH_MEDICO_EMAIL_API_ERROR ],
    endpoint: `/medico/search/findByEmail?email=${email}&projection=medicoProjection`
  }
});


export const getMedicoByEmail = (email) => (dispatch, getState) => {
  // const email = getState().auth.usuarioLogueado.email
  return dispatch(fetchMedicoEmail(email))
};


export const UPDATE_USER_DATA = "UPDATE_USER_DATA";

export const updateCurrentUserData = payload => ({
  type: UPDATE_USER_DATA,
  payload,
});


/**
 * Endpot para obtener Medico Logueado Segun credenciales
 * @type {string}
 */
export const GET_MEDICO_LOGUEADO_API_REQUEST = "API/MEDICO_LOGUEADO/request";
export const GET_MEDICO_LOGUEADO_API_SUCCESS = "API/MEDICO_LOGUEADO/success";
export const GET_MEDICO_LOGUEADO_API_FAILURE = "API/MEDICO_LOGUEADO/failure";


const fetchMedicoLogueado = () => ({
  [CALL_API]: {
    method: 'GET',
    types: [
      GET_MEDICO_LOGUEADO_API_REQUEST,
      GET_MEDICO_LOGUEADO_API_SUCCESS,
      GET_MEDICO_LOGUEADO_API_FAILURE
    ],
    endpoint: `/auth/medico`
  }
});


export const getMedicoLogueado = () => (dispatch, getState) => {
  return dispatch(fetchMedicoLogueado())
};


// WEBPACK FOOTER //
// ./src/security/services/auth.js